import { render, staticRenderFns } from "./extra-details-parents.vue?vue&type=template&id=38e4fbea&scoped=true&"
import script from "./extra-details-parents.vue?vue&type=script&lang=js&"
export * from "./extra-details-parents.vue?vue&type=script&lang=js&"
import style0 from "./extra-details-parents.vue?vue&type=style&index=0&id=38e4fbea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4fbea",
  null
  
)

export default component.exports